
import usecase from '../application/usecase.mjs';

class Coordinator {

    #elements;

    constructor (elements) {
        this.#elements = elements;
        Object.freeze(this);
    }

    static build () {
        const map = Coordinator.mapElements(
              'result'
            , 'length'
            , 'flag:lowercase'
            , 'flag:uppercase'
            , 'flag:number'
            , 'flag:ambiguous'
        );

        return new Coordinator(map);
    }

    static mapElements (...elementIDs) {
        const map = new Map();

        for (const elementID of elementIDs) {
            map.set(elementID, document.getElementById(elementID));
        }

        return map;
    }

    coordinate () {
        this.#initializeEvents();
        this.#initializeEffects();
    }

    #initializeEvents () {
        this.#elements.get('length').addEventListener('change', _ => this.#process());
        this.#elements.get('flag:lowercase').addEventListener('change', _ => this.#process());
        this.#elements.get('flag:uppercase').addEventListener('change', _ => this.#process());
        this.#elements.get('flag:number').addEventListener('change', _ => this.#process());
        this.#elements.get('flag:ambiguous').addEventListener('change', _ => this.#process());
        this.#process();

        this.#elements.get('result').addEventListener('click', event => navigator.clipboard.writeText(event.target.textContent));
    }

    #initializeEffects () {
        for (const element of document.getElementsByClassName("paste-effect")) {
            element.addEventListener('transitionend', event => event.target.classList.remove('pasted'));
        }
        for (const element of document.getElementsByClassName("click-effect")) {
            element.addEventListener('click', event => event.target.classList.add('clicked'));
            element.addEventListener('transitionend', event => event.target.classList.remove('clicked'));
        }
    }

    #process () {
        this.#elements.get('result').textContent = usecase.process(
              this.#elements.get('length').valueAsNumber
            , this.#elements.get('flag:lowercase').checked
            , this.#elements.get('flag:uppercase').checked
            , this.#elements.get('flag:number').checked
            , this.#elements.get('flag:ambiguous').checked
        );
    }

}

export default Coordinator.build();
